import React from "react";
//#region types
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { ACTION_SEPARATOR, MoreActionMenuItemType } from "models/propTypes/menuPropTypes";
import { GenericDocumentMoreActionProps } from "models/propTypes/documentPropTypes";
import { StyleEnums, DialogEnums } from "models/enums";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
//#region components
import { MoreActions, useCheckRelations } from "components/common";
import { useGenericDocumentService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const GenericDocumentMoreActions: React.FC<GenericDocumentMoreActionProps> = (props) => {
  const genericDocumentService = useGenericDocumentService();
  const { document, markAsDeleteDocument } = props;

  const { getIsReadonlyUser } = useCheckRelations();

  //#region download
  const onDownloadClick = async () => {
    await genericDocumentService.download(document.id);
  };

  const downloadAction: MoreActionMenuItemType = {
    description: `${LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Download)}`,
    icon: IconDefinitionConstants.WDownload,
    onClickHandler: onDownloadClick,
  };
  //#endregion

  //#region cancel document
  const onClickDelete = () => genericDocumentService.deleteDocument(document.id);

  const deleteDocumentAction: MoreActionMenuItemType = {
    description: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Delete),
    icon: IconDefinitionConstants.WTrashAlt,
    actionDialog: {
      isOpen: false,
      title: `${LocalizationHelperInstance.getFormattedMessage(
        TranslationKeys.Common.Delete
      )} ${LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Document.Document)}?`,
      titleIcon: IconDefinitionConstants.WTrashAlt,
      actions: [
        {
          text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Delete),
          onClick: onClickDelete,
          type: StyleEnums.DisplayType.Danger,
          successMessage: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Document.DeleteSuccessMessage),
        },
      ],
      dialogType: DialogEnums.DialogType.Message,
      children: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.DeleteWarningMessage),
      type: StyleEnums.DisplayType.Danger,
    },
    highlightType: StyleEnums.DisplayType.Danger,
    onActionSuccess: markAsDeleteDocument,
  };
  //#endregion

  const getMenuItems = (): MoreActionMenuItemType[] => {
    const actions: MoreActionMenuItemType[] = [];
    const isReadOnlyUser = getIsReadonlyUser();

    if (!isReadOnlyUser) {
      actions.push(downloadAction);
      if (document.state !== WintSuperkollAPIModel.GenericDocumentState.Booked) {
        actions.push(ACTION_SEPARATOR);
        actions.push(deleteDocumentAction);
      }
    } else {
      actions.push(downloadAction);
    }

    return actions;
  };

  return <MoreActions menuItems={getMenuItems()} />;
};

export default GenericDocumentMoreActions;
